<div class="cotizacion-cemento-filtros">
  <div class="cotizacion-cemento-filtro-buscar">
    <app-cbb-field
      label="Buscar"
      placeholder="Código, cliente, RUT, email..."
      [clearable]="true"
      [ngModel]="store.searchTerm()"
      (ngModelChange)="onSearchTermChange($event)"
    ></app-cbb-field>
  </div>
  <div class="cotizacion-cemento-filtro-acciones">
    <app-cbb-button
      label="Exportar Excel"
      color="info"
      (action)="onExportExcel()"
      [disabled]="store.loading()"
    ></app-cbb-button>
    <app-cbb-button
      label="Generar PDF Cotización"
      color="green"
      (action)="onOpenSearchPdf()"
      [disabled]="store.loading()"
    ></app-cbb-button>
  </div>
</div>

<div *ngIf="store.error()" class="alert alert-warning py-2" role="alert">{{ store.error() }}</div>

<app-admin-server-table
  [columns]="tableColumns"
  [rows]="store.items()"
  [loading]="store.loading()"
  [emptyMessage]="'No hay cotizaciones para mostrar.'"
  [ordering]="store.ordering()"
  [pagination]="paginationState"
  [summaryNoun]="'cotizaciones'"
  [rowTrackBy]="trackByItem"
  (orderingChange)="onOrderingChange($event)"
  (pageChange)="onPageChange($event)"
  (pageSizeChange)="onPageSizeChange($event)"
></app-admin-server-table>

<ng-template #priceCellTpl let-row>
  <span>{{ row.total_price | number:'1.0-0':'es-CL' }}</span>
</ng-template>

<ng-template #actionsCellTpl let-row>
  <div class="d-flex gap-1 justify-content-center align-items-center">
    <button
      class="cbb-icon-action cbb-icon-action--primary"
      title="Ver detalle"
      [disabled]="store.loading()"
      (click)="onSeeVariables(row)"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"/>
        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"/>
      </svg>
    </button>
    <button
      class="cbb-icon-action cbb-icon-action--success"
      title="Descargar PDF"
      [disabled]="store.loading()"
      (click)="onDownloadPdf(row.order_buy)"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z"/>
      </svg>
    </button>
  </div>
</ng-template>
